import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { content } from '../content/content';
import { useCampaigns } from '../hooks/useCampaigns';
import CampaignCard from './CampaignCard';

type CampaignsListProps = {
  magazineName?: string;
  magazineId?: string;
  categories?: string[];
};

const CampaignsList: React.FC<CampaignsListProps> = ({ magazineId, categories, magazineName }) => {
  const campaigns = useCampaigns({ magazineId, categories });
  return (
    <Box>
      <Typography fontSize={17} mb={2}>
        {`${content.components.campaignList.title} (${campaigns.length})`}
      </Typography>
      {campaigns.map((campaign, i) => (
        <CampaignCard key={i} campaign={campaign} displayMagazineName={true} magazineName={magazineName} />
      ))}
    </Box>
  );
};

export default CampaignsList;

